/**
 * @fileoverview gRPC-Web generated client stub for reportpb
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');



const proto = {};
proto.reportpb = require('./balance_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.reportpb.BalanceServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.reportpb.BalanceServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reportpb.ListBalanceRequest,
 *   !proto.reportpb.ListBalanceResponse>}
 */
const methodDescriptor_BalanceService_ListBalance = new grpc.web.MethodDescriptor(
  '/reportpb.BalanceService/ListBalance',
  grpc.web.MethodType.UNARY,
  proto.reportpb.ListBalanceRequest,
  proto.reportpb.ListBalanceResponse,
  /**
   * @param {!proto.reportpb.ListBalanceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.ListBalanceResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.reportpb.ListBalanceRequest,
 *   !proto.reportpb.ListBalanceResponse>}
 */
const methodInfo_BalanceService_ListBalance = new grpc.web.AbstractClientBase.MethodInfo(
  proto.reportpb.ListBalanceResponse,
  /**
   * @param {!proto.reportpb.ListBalanceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.ListBalanceResponse.deserializeBinary
);


/**
 * @param {!proto.reportpb.ListBalanceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.reportpb.ListBalanceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reportpb.ListBalanceResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reportpb.BalanceServiceClient.prototype.listBalance =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reportpb.BalanceService/ListBalance',
      request,
      metadata || {},
      methodDescriptor_BalanceService_ListBalance,
      callback);
};


/**
 * @param {!proto.reportpb.ListBalanceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reportpb.ListBalanceResponse>}
 *     Promise that resolves to the response
 */
proto.reportpb.BalanceServicePromiseClient.prototype.listBalance =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reportpb.BalanceService/ListBalance',
      request,
      metadata || {},
      methodDescriptor_BalanceService_ListBalance);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reportpb.ListDashboardBalanceRequest,
 *   !proto.reportpb.ListDashboardBalanceResponse>}
 */
const methodDescriptor_BalanceService_ListDashboardBalance = new grpc.web.MethodDescriptor(
  '/reportpb.BalanceService/ListDashboardBalance',
  grpc.web.MethodType.UNARY,
  proto.reportpb.ListDashboardBalanceRequest,
  proto.reportpb.ListDashboardBalanceResponse,
  /**
   * @param {!proto.reportpb.ListDashboardBalanceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.ListDashboardBalanceResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.reportpb.ListDashboardBalanceRequest,
 *   !proto.reportpb.ListDashboardBalanceResponse>}
 */
const methodInfo_BalanceService_ListDashboardBalance = new grpc.web.AbstractClientBase.MethodInfo(
  proto.reportpb.ListDashboardBalanceResponse,
  /**
   * @param {!proto.reportpb.ListDashboardBalanceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.ListDashboardBalanceResponse.deserializeBinary
);


/**
 * @param {!proto.reportpb.ListDashboardBalanceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.reportpb.ListDashboardBalanceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reportpb.ListDashboardBalanceResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reportpb.BalanceServiceClient.prototype.listDashboardBalance =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reportpb.BalanceService/ListDashboardBalance',
      request,
      metadata || {},
      methodDescriptor_BalanceService_ListDashboardBalance,
      callback);
};


/**
 * @param {!proto.reportpb.ListDashboardBalanceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reportpb.ListDashboardBalanceResponse>}
 *     Promise that resolves to the response
 */
proto.reportpb.BalanceServicePromiseClient.prototype.listDashboardBalance =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reportpb.BalanceService/ListDashboardBalance',
      request,
      metadata || {},
      methodDescriptor_BalanceService_ListDashboardBalance);
};


module.exports = proto.reportpb;

